export const initialState = {
  selectedCloudAccountGuid: null,
};

export function SET_CLOUD_ACCOUNT(nextState, { selectedCloudAccountGuid }) {
  nextState.selectedCloudAccountGuid = selectedCloudAccountGuid;
}
